<template>
  <div>
    <blog-grid-view />
  </div>
</template>

<script>
export default {
  name: 'PageBlog',

  components: {
    BlogGridView: () => import('@/components/blog/blog-grid-view')
  },

  mounted() {
  },

  metaInfo: {
    title: 'Bliss Applications: User-centered design company'
  }
};
</script>



// WEBPACK FOOTER //
// index.vue